/*eslint-disable */
const $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import {bus} from '@/main';  
export default {
  name: 'appointment-status-change-popup',
  components: {},
  props: ['appointmentStatusForData', 'appointmentStatusForFLAG'],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    appointmentStatusUpdatedFun(){
      var appointment_status;
      var status_message;
      if(this.appointmentStatusForFLAG == 'Apporve'){
        appointment_status = 'appointment_confirmed'
        status_message =  'Appointment has been confirmed'
        var data = {
          is_approved: true,
        }
      }else if(this.appointmentStatusForFLAG == 'Cancel'){
        appointment_status = 'appointment_cancelled'
        status_message = 'Appointment has been cancelled'
        var data = {
          is_cancelled: true,
        }
      }else if(this.appointmentStatusForFLAG == 'Close'){
        appointment_status = 'appointment_closed',
        status_message = 'Appointment has been closed'
        var data = {
          is_closed: true,
        }
      }
      this.$store.dispatch('updateAppointmentDetailsMethod', {data:{id:this.appointmentStatusForData.id,data:data}}).then((res)=>{
        this.$store.dispatch('getconsultPatientDetailyIdMethod', {id:this.appointmentStatusForData.id}).then((res) => {
          bus.$emit('consultPatientInfoBus', res.data.data.data)
          let notificationPayload = { 
            type:appointment_status,
            data_id:res.data.data.data.id,
            message:status_message
          }
          this.$store.dispatch('postNotificationFunc', notificationPayload)
          toast.success(res.data.msg);
          this.$store.dispatch('getconsultPatientMethod')
          this.appointmentStatusPopupDecline()
        })
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
    appointmentStatusPopupDecline(){
      bus.$emit('appointmentStatusPopupBus', false)
    }
  }
}


